import { WImage, WLink } from '@components/atoms'
import { ChevronDown, Close } from '@components/icons'
import { BrandType } from '@components/molecules/HeaderBrand/HeaderBrand'
import { ReactNode, useEffect, useRef, useState } from 'react'
import { useTrans } from '../../../hooks'
import styles from './HeroStickyBarMobile.module.sass'
import { trackingGAevent } from '@utils/gtm'

interface Props {
  isOpen?: boolean
  className?: string
  variant?: 'default' | 'label'
  label?: string
  logo?: string
  options?: { label?: string; url?: string }[]
}

const HeroStickyBarMobile = (props: Props) => {
  const {
    isOpen = false,
    className = '',
    variant = 'default',
    label = undefined,
    options = [],
    logo = undefined,
  } = props

  const [open, setOpen] = useState(false)
  const [height, setHeight] = useState(undefined)
  const innerContentRef = useRef<HTMLDivElement>(null)

  const t = useTrans()

  const handleClickTracking = (item) => {
    trackingGAevent('click_menu_brand', {
      click_text: item?.label || '', //The clicked text
      click_url: item?.url || '', //The clicked links
    })
  }

  useEffect(() => {
    if (isOpen) setOpen(true)
  }, [])

  useEffect(() => {
    setHeight(open ? innerContentRef.current?.clientHeight + 16 : 0)
  }, [open, setHeight, innerContentRef.current?.clientHeight])

  return (
    <div
      className={`${styles.root} ${className} ${variant === 'label' ? styles['root--label'] : ''}`}
    >
      <div
        className={`${styles.container} ${open ? styles['container--open'] : ''} ${
          variant === 'label' && open ? styles['container--label'] : ''
        }`}
      >
        <button
          aria-expanded={open}
          type="button"
          onClick={() => setOpen(!open)}
          className={styles.trigger}
        >
          {logo && (
            <div className={styles.logo}>
              <WImage src={logo} maxWidth={240} maxHeight={33} />
            </div>
          )}
          {label && <p className={styles.triggerLabel}>{label}</p>}
          <span className={styles.triggerIcon}>{open ? <Close /> : <ChevronDown />}</span>
        </button>
        <div
          id={`panel`}
          aria-labelledby={`label`}
          className={styles.content}
          style={{
            height: height !== undefined ? `${height}px` : undefined,
          }}
        >
          <div className={styles.innerContent} ref={innerContentRef}>
            {options.map((item, index) => (
              <div className={styles.link} key={index}>
                <WLink next={false} href={item.url} onClick={handleClickTracking}>
                  {item.label}
                </WLink>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroStickyBarMobile
